import React from 'react';
import ReactGA from 'react-ga';
import GIECard from '../../components/GIECard/GieCard';
import GIETextField from '../../components/GIETextField/GieTextField';
import GIEButton from '../../components/GIEButton/GieButton';
import {FormValidator} from '../../util/form-validator';
import LoginController from '../../controller/login.controller';
import {StringUtil} from '../../util/string-util';
import userInformations from '../../userInformation/user_informations';

export default class LoginTenant extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();
  loginController: LoginController = new LoginController();

  constructor(props) {
    super(props);
    this.state = {
      letterRef: {
        value: '',
        error: false,
        errorMessage: ''
      }
    }
    userInformations.removeToken();
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  changeHandler = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    if (name === 'identifier') {
      value = StringUtil.displayCorrectContractNumber(value)
    }
    const error = this.formValidator.returnError(value, name);
    this.setState({
      ...this.state,
      [name]: {
        ...this.state[name],
        value,
        error: error.error,
        errorMessage: error.errorMessage
      }
    });
  }

  checkValidForm = () => {
    let formControls = this.state;
    let isError = false;
    Object.keys(formControls).forEach(name => {
      const error = this.formValidator.returnError(formControls[name].value, name)
      formControls[name].error = error.error;
      formControls[name].errorMessage = error.errorMessage;

      if (error.error === true) {
        isError = true
      }
    });
    this.setState(formControls)
    return isError;
  }

  authenticateTenant = () => {
    if (this.checkValidForm() === false) {
      const request = {
        letterRef: this.state.letterRef.value
      }
      this.loginController.loginTenant(request).then((user: any) => {
        userInformations.setRole('tenant');
        userInformations.setNoContract(user.contract)
        userInformations.setToken(user.access_token)
        window.location.href = "/admin/rendez-vous";
      }).catch(err => {
        this.manageError(err)
      })
    }
  }

  manageError = (err) => {
    const formControls = this.state;
    if (err && err.response && err.response.status === 401) {
      formControls.letterRef.error = true;
      formControls.letterRef.errorMessage = 'Mauvaise référence courrier ou pas d’intervention prévue';
    } else if (err && err.response && err.response.status === 403) {
      formControls.letterRef.error = true;
      formControls.letterRef.errorMessage = "Impossible de modifier cette intervention";
    } else {
      formControls.letterRef.error = true;
      formControls.letterRef.errorMessage = "Une erreur s'est produite";
    }

    this.setState(formControls);
  }

  render() {
    return (
      <div className="content">
        <div className="blue-bg-container">
          <form className="m-auto">
            <GIECard width="500px" height="100%">
              <div className="p-4">
                <h2 className="text-center">Je modifie mon rendez-vous d’entretien annuel</h2>
                <div className="my-4">
                  <div className="mb-3">Ce service est proposé aux occupants d’un logement sous contrat d’entretien individuel</div>
                  <GIETextField label="Référence de votre intervention"
                                required
                                autocomplete="off"
                                type="text"
                                name="letterRef"
                                onChange={e => this.changeHandler(e)}
                                value={this.state.letterRef.value}
                                helperText={this.state.letterRef.errorMessage}
                                error={this.state.letterRef.error}
                                infoText={"La référence de votre intervention se trouve sur votre courrier de visite annuelle d’entretien (exemple : II000000000)"}/>
                </div>
                <div className="text-center">
                  <GIEButton onClick={this.authenticateTenant} classes={{root: 'orange-btn'}}>Connexion</GIEButton>
                </div>
              </div>
            </GIECard>
          </form>
        </div>
      </div>
    );
  }
}
